import Component from './Loading';

export default Component;
